import moment from "moment";
import { DIAS } from "../consts";

export const MESES = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const getMonthStart = (fecha) => moment(fecha).startOf("month");

// "Julio 2026"
export const formatMonthLabel = (monthStart) =>
    `${MESES[moment(monthStart).month()]} ${moment(monthStart).year()}`;

// Valor del param `mes` que va a recibir el service real: "YYYY-MM".
export const monthKey = (monthStart) => moment(monthStart).format("YYYY-MM");

/**
 * Si un `field` de columna es una celda-DIA.
 *
 * Por inclusion y no por descarte: las columnas que no son dias —empleado, horas, la de
 * checkboxes— van cambiando, y una lista de excepciones se desactualiza sin que nadie se
 * entere. Un `field` de dia siempre tiene la forma YYYY-MM-DD porque lo genera
 * `getDiasDelMes`.
 */
export const esCampoDia = (field) => /^\d{4}-\d{2}-\d{2}$/.test(field ?? "");

// "Martes 15/07" — para títulos de detalle de una celda-día.
export const formatDiaLabel = (field) => {
    // Sin la guarda, un field que no sea fecha da `DIAS[NaN - 1]`, o sea undefined, y leerle
    // `.label` tira. Como esto se evalua en el render del modal de detalle, eso rompia la
    // vista entera y no solo el titulo.
    if (!esCampoDia(field)) return "";
    const fecha = moment(field);
    return `${DIAS[fecha.isoWeekday() - 1].label} ${fecha.format("DD/MM")}`;
};


export const getDiasDelMes = (monthStart) => {
    const inicio = getMonthStart(monthStart);
    const cantidad = inicio.daysInMonth();
    return Array.from({ length: cantidad }, (_, i) => {
        const fecha = moment(inicio).add(i, "days");
        return {
            field: fecha.format("YYYY-MM-DD"),
            label: `${DIAS[fecha.isoWeekday() - 1].abrev}/${fecha.format("DD")}`,
            esHoy: fecha.isSame(moment(), "day"),
        };
    });
};
